import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import PrivateLayout, { ProtectedRoute }  from '../layout/PrivateLayout'; 
import GetTicketPage from "../pages/event/getTicket";
import TicketPage from "../pages/order/ticket";
import PreviewPage from "../pages/event/preview/PreviewPage";
import Profile from '../pages/customer/Profile';
import GetTicketWrapper from '../pages/event/getTicket/GetTicketWrapper';

const PrivateRoute = () => {
    return (
        <Routes>
             <Route path="/p/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
             {/* <Route path="/event/:id/get-ticket" element={<ProtectedRoute><GetTicketPage /></ProtectedRoute>} /> */}
             {/* <Route path="/event/:id/get-ticket" element={<ProtectedRoute><GetTicketWrapper /></ProtectedRoute>} /> */}
             <Route path="/event/:slug/get-ticket" element={<ProtectedRoute><GetTicketWrapper /></ProtectedRoute>} />
             <Route path="/tickets" element={<ProtectedRoute><TicketPage /></ProtectedRoute>} />
             <Route path="/preview/:id" element={<ProtectedRoute><PreviewPage /></ProtectedRoute>} />
            {/* <Route path="/p/favorites" element={<ProtectedRoute><FavoritesPage /></ProtectedRoute>} /> */}
        </Routes>
    )
}

export default PrivateRoute

